import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { questionsQueryKeys } from './questionsQueryKeys';

const getQuestionAttachment = async ({ questionId, fileName }) => {
  return await request.get(
    `/Question/attachment`,
    { questionId, fileName },
    'При загрузке файла произошла ошибка',
    'Error'
  );
};

const useQuestionAttachment = ({ id, questionId, fileName }, options) =>
  useQuery(
    questionsQueryKeys.attachment(id),
    () => getQuestionAttachment({ questionId, fileName }),
    options
  );

export default useQuestionAttachment;
